import { default as angular } from "angular";
import uiRouter from "@uirouter/angularjs/lib-esm";

import { moduleName as recordsModuleName } from "../records";
import { routeConfig } from "./routes";

import {
  vsName as MachineDetailDepreciationComponentName,
  machineDetailDepreciationComponentOptions,
  machineDetailDepreciationComponentConfig,
} from "./views/machineDetail/Depreciation";
import {
  vsComponentName as MachineDetailDepreciationEditComponentName,
  MachineDetailDepreciationEditComponentOptions,
} from "./views/machineDetail/Depreciation/DepreciationEdit";

export const vsName = "SlotTrak.Depreciation";

angular
  .module(vsName, [uiRouter, recordsModuleName])
  .config(routeConfig)
  .config(machineDetailDepreciationComponentConfig)
  .component(
    MachineDetailDepreciationComponentName,
    machineDetailDepreciationComponentOptions
  )
  .component(
    MachineDetailDepreciationEditComponentName,
    MachineDetailDepreciationEditComponentOptions
  );

export default vsName;
